import React from "react";
import FeatureCard from "../FeatureCard";

export default () => (
  <FeatureCard to="/test-credentials/entry" image="/static/img/Card-SeeTheCode.png" imageAlt="Laptop with code" description="Submit SMS credentials">
    Test your SMS credentials
  </FeatureCard>
);
